<template>
  <section>
    <nav class="sidebar-nav" :class="{ toggle: toggler }">
      <div class="last-build">
        <p>
          Current version: <span>{{ version }}</span
          ><br />
          {{
            getComputedDate.build
              | formatDateComputed({
                format: getManagerUserProfile.format_date,
                timezone: getManagerUserProfile.timezone,
                hasHourAndMinutes: true,
              })
          }}
        </p>
      </div>
      <div class="sidebar-logo">
        <svgHelper name="logo"></svgHelper>
      </div>
      <ul class="list-group list-unstyled">
        <li id="v-step-0">
          <router-link
            :to="{
              name: getAccType === 'manager' ? 'manager-dashboard' : 'manager-user-dashboard',
            }"
            class="list-group-item list-group-item-action"
            :class="
              getGuide.show && getGuide.step === 2
                ? 'animate__animated animate__headShake animate__infinite	animate__slow  animate__delay-2s'
                : ''
            "
          >
            <i class="far fa-chart-bar mr-4"></i>Dashboard
          </router-link>
        </li>

        <li class="holder">
          <router-link
            :to="{
              name: getAccType === 'manager' ? 'manager-pipelines' : 'manager-user-pipelines',
            }"
            class="list-group-item list-group-item-action"
            :class="
              getGuide.show && getGuide.step === 2
                ? 'animate__animated animate__headShake animate__infinite	animate__slow'
                : ''
            "
          >
            <i class="fas fa-filter mr-4"></i>Pipelines
          </router-link>
          <div
            v-if="getGuide.show === true && getGuide.step === 2"
            class="guide-box animate__animated animate__fadeIn animate__faster"
          >
            <span>Dashboard and Pipelines</span>
            <img src="https://jobshark.eu/img/3.jpg" alt="jobshark candidates" />
            <p>
              On the interactive Pipeline page, you can view the candidates at each stage. The
              Dashboard provides a comprehensive overview of your recruiting projects.
            </p>
            <div class="buttons">
              <button @click="closeGuide" class="btn btn-danger">Close</button>
              <button @click="nextStep" class="btn btn-primary">Next</button>
            </div>
          </div>
        </li>

        <li>
          <router-link
            :to="{
              name: getAccType === 'manager' ? 'manager-candidates' : 'manager-user-candidates',
            }"
            class="list-group-item list-group-item-action"
            :class="
              getGuide.show && getGuide.step === 1
                ? 'animate__animated animate__headShake animate__infinite	animate__slow animate__delay-2s'
                : ''
            "
          >
            <i class="fas fa-user-alt mr-4"></i>Candidates
          </router-link>
        </li>
        <li class="holder">
          <router-link
            :to="{ name: getAccType === 'manager' ? 'manager-jobs' : 'manager-user-jobs' }"
            class="list-group-item list-group-item-action"
            :class="
              getGuide.show && getGuide.step === 1
                ? 'animate__animated animate__headShake animate__infinite	animate__slow'
                : ''
            "
          >
            <i class="fas fa-briefcase mr-4"></i>Jobs
          </router-link>
          <div
            v-if="getGuide.show === true && getGuide.step === 1"
            class="guide-box animate__animated animate__fadeIn animate__faster"
          >
            <span>Jobs and Candidates</span>
            <img src="https://jobshark.eu/img/candidates.jpg" alt="jobshark candidates" />
            <p>
              On the Jobs page, you can manage your posted jobs, while the Candidates page allows
              you to oversee the applicants. You can easily access contact information for the
              candidates, review CVs, book interviews, etc.
            </p>
            <div class="buttons">
              <button @click="closeGuide" class="btn btn-danger">Close</button>
              <button @click="nextStep" class="btn btn-primary">Next</button>
            </div>
          </div>
        </li>
        <li v-if="canSeeMixin(['manager'])">
          <router-link
            :to="{ name: 'manager-profile' }"
            class="list-group-item list-group-item-action"
          >
            <i class="fas fa-city mr-4"></i>Employer
          </router-link>
        </li>

        <li class="signout mt-3">
          <router-link
            class="list-group-item list-group-item-action"
            :to="{
              name: getSettings,
            }"
            ><i class="fas fa-cog mr-4"></i> <span>Settings</span></router-link
          >
        </li>

        <li class="signout">
          <router-link
            class="list-group-item list-group-item-action"
            :to="{ name: 'manager-support' }"
            ><i class="far fa-question-circle mr-4"></i> <span>Support</span></router-link
          >
        </li>

        <li class="signout" @click="logout">
          <span class="list-group-item list-group-item-action">
            <i class="fas fa-sign-out-alt mr-4"></i>Sign Out
          </span>
        </li>
        <li
          v-if="getManagerRecent.length > 0 && getManagerRecent[0].hasOwnProperty('job_id')"
          class="mt-1"
        >
          <router-link
            :to="{
              name: 'manager_job_uuid',
              params: {
                manager_job_uuid: getManagerRecent[0].job_id,
                job_name: getManagerRecent[0].job_name,
              },
            }"
          >
            <span class="list-group-item list-group-item-action">
              <i class="fas fa-stopwatch mr-4"></i>Recent
            </span>
          </router-link>

          <router-link
            v-if="getManagerRecent.length > 0 && getManagerRecent[0].hasOwnProperty('candidate_id')"
            :to="{
              name: 'manager_candidate_id',
              params: {
                manager_candidate_id: getManagerRecent[0].candidate_id,
              },
            }"
          >
            <span class="list-group-item list-group-item-action">
              <i class="fas fa-stopwatch mr-4"></i>Recent
            </span>
          </router-link>
        </li>
        <li v-else class="mt-1">
          <router-link
            v-if="getManagerRecent.length > 0"
            :to="{
              name: 'manager_candidate_id',
              params: {
                manager_candidate_id: getManagerRecent[0].candidate_id,
              },
            }"
          >
            <span class="list-group-item list-group-item-action">
              <i class="fas fa-stopwatch mr-4"></i>Recent
            </span>
          </router-link>
        </li>
        <li class="mt-1">
          <ul class="list-group recent-group">
            <li v-for="recent in getManagerRecent" :key="recent.id" class="recent-item">
              <router-link
                v-if="recent.hasOwnProperty('job_id')"
                :to="{
                  name: 'manager_job_uuid',
                  params: { manager_job_uuid: recent.job_id, job_name: recent.job_name },
                }"
              >
                {{ recent.job_name }}</router-link
              >
              <router-link
                v-else
                :to="{
                  name: 'manager_candidate_id',
                  params: {
                    manager_candidate_id: recent.candidate_id,
                  },
                }"
              >
                {{ recent.candidate }}</router-link
              >
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </section>
</template>

<script>
import moment from 'moment';
import { canSeeMixin } from '../../mixins/canSeeMixin';
import { mapActions, mapGetters } from 'vuex';
import version from '../../version';
import axios from 'axios';
// import { mapGetters } from 'vuex';
export default {
  props: ['toggler'],
  mixins: [canSeeMixin],
  data: () => ({
    version: version,
    isHovering: false,
    bugs: 30,
    showLastRecent: false,
  }),
  methods: {
    ...mapActions('managerStoreModule', ['retrieveManagerRecent', 'setGuideStep']),
    logout() {
      this.$store
        .dispatch('destroyToken')
        .then(() => {
          this.$router.push('/');
          sessionStorage.removeItem('first');
          this.$toasted.show('You are successfully logged out', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(() => {
          this.$router.push('/');

          this.$toasted.error('You are successfully logged out.', {
            theme: 'bubble',
            icon: 'fa-exclamation-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },
    nextStep() {
      this.setGuideStep(this.getGuide.step + 1);
    },
    closeGuide() {
      this.$store.commit('managerStoreModule/SET_GUIDE_SHOW', false);
      this.hideGuide();
    },

    hideGuide() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/manager/updateguidescreen`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.intro = false;
        });
    },
  },
  computed: {
    ...mapGetters(['getAccType']),
    ...mapGetters('managerStoreModule', ['getManagerRecent', 'getManagerUserProfile', 'getGuide']),
    getComputedDate() {
      const buildDateElementFromIndex = document.documentElement.getAttribute(
        'data-build-timestamp-utc',
      );

      return {
        build: moment(buildDateElementFromIndex),
      };
    },
    getSettings() {
      switch (this.getAccType) {
        case 'manager':
          return 'manager-settings';
        case 'admin':
          return 'admin-settings';
        case 'candidate':
          return 'candidate-user-settings';
        case 'recruiter':
          return 'recruiter-settings';
        case 'user':
          return 'manager-settings';
        default:
          return '';
      }
    },
  },
  watch: {
    // Watch for changes to the computed property
    getManagerRecent(newValue, oldValue) {
      // Do something when the value of getManagerRecent changes
      this.showLastRecent = true;
    },
  },
  mounted() {
    this.retrieveManagerRecent();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.holder {
  position: relative;
  .guide-box {
    background-color: #eeeded;
    position: absolute;
    left: 112%;
    top: -150px;
    padding: 20px;
    width: 320px;
    z-index: 9999;
    border: 1px solid #ddd;
    border-radius: 12px;
    box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.2);
    span {
      font-size: 18px;
      display: block;
      font-weight: 600;
      margin-bottom: 15px;
    }
    img {
      max-width: 100%;
      height: auto;
    }
    p {
      font-size: 14px;
    }
    .buttons {
      display: flex;
      gap: 15px;
      .btn {
        flex: 1;
        font-size: 13px;
      }
    }
  }
}

.signout {
  cursor: pointer;
  display: none;
}

a {
  text-decoration: none !important;
}

.recent-group {
  margin: 12px 0;
  .recent-item {
    margin: 0 !important;
    max-width: 175px;
    a {
      padding: 6px 20px;
      color: #fff;
      text-decoration: none;
      font-size: 13px;
      display: block;
      background: none !important;
    }
    &:hover {
      cursor: pointer;
      background: rgba(255, 255, 255, 0.1);
    }
  }
}
.fa-city {
  font-size: 11px;
}

.sidebar-logo {
  text-align: center;
  padding: 2rem;

  .svg-icon {
    width: 80px;
    height: 75px;
    margin-left: 10px;
  }
}

.dropdown {
  a::after {
    transform: rotate(-90deg);
  }
}

.dropdown-menu {
  background-color: rgb(14, 14, 14);
  margin-left: 100%;
  margin-top: -45px !important;
  border: 0 !important;
  border-radius: 0;

  a {
    color: $color-white;
    font-size: 14px;
  }

  a:hover {
    background-color: #f05a00;
  }
}
.last-build {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: 0 auto;
  font-size: 0.7rem;
  color: rgb(180, 180, 180);
  text-align: center;
  p {
    margin: 0 0 0 -5px;
  }
}

@media only screen and (max-width: 1250px) {
  .signout {
    cursor: pointer;
    display: block;
  }
}
</style>
